<template lang="pug">
  .accordion(:class="accordionClass" :aria-expanded="active ? 'true' : 'false'")
    button.accordion__header.accordion__label.flex.align-left.justify-between(type="button" :class="headerClass", @click="activate" tabindex="0")
      span.h6 {{ heading }}
      icon(v-if="showIcon" :name="currentIcon", size="24px")
    transition(:name="transition")
      .accordion__content(v-if="active", ref="content", :style="contentStyle")
        .accordion__content-wrapper
          slot
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'Accordion',
    components: { Icon },
    props: {
      heading: {
        type: String,
        required: true,
      },
      selected: {
        type: Boolean,
        default: false,
      },
      activeIcon: {
        type: String,
        default: 'minus',
      },
      inactiveIcon: {
        type: String,
        default: 'plus',
      },
      showIcon: {
        type: Boolean,
        default: false,
      },
      theme: {
        type: String,
        default: 'default',
        validator(value) {
          return ['default', 'footer', 'customizer'].includes(value);
        },
      },
    },
    data() {
      return {
        active: this.selected || true,
        contentStyle: {},
        scrollHeight: 0,
        transition: 'none',
      };
    },
    computed: {
      accordionClass() {
        const classes = [];

        if (this.theme !== 'default') {
          classes.push(`accordion--${this.theme}`);
        }

        classes.push(this.headerClass);

        return classes;
      },
      headerClass() {
        return {
          'is-open': this.active,
        };
      },
      currentIcon() {
        return this.active ? this.activeIcon : this.inactiveIcon;
      },
    },
    mounted() {
      this.setContentHeight();

      // NOTE: this has to be set to false after mount or scrollHeight will be 0
      this.active = this.selected;
      this.transition = 'slide-vertical';

      if (this.$parent.addAccordion) {
        this.$parent.addAccordion(this);
      }
    },
    beforeDestroy() {
      this.active = false;
      if (this.$parent.removeAccordion) {
        this.$parent.removeAccordion(this);
      }
    },
    methods: {
      setContentHeight() {
        const height = this.$refs.content && this.$refs.content.scrollHeight ? this.$refs.content.scrollHeight : 999;
        const containerPadding = 50;

        // Set max height for animation
        this.contentStyle = {
          'max-height': `${height + containerPadding}px`,
        };
      },
      activate() {
        this.active = !this.active;

        this.$nextTick(() => this.setContentHeight());
      },
    },
  };
</script>

<style scoped lang="scss">
  .accordion {
    &__content {
      overflow: hidden;

      &.slide-vertical-leave-active {
        padding-bottom: 0;
      }
    }
  }
</style>
